jQuery(function () {

    // ==========================
    // CONTACT FORM VALIDATION
    // ==========================

    jQuery(document).on('submit', '#ContactForm', function (e) {

        let isValid = true;

        jQuery('.error-msg').remove();
        jQuery('.form-error-summary').remove();
        jQuery('.field__input').removeClass('input-error');

        const nameRegex = /^[A-Za-zÀ-ÿ\s'-]{2,}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        let firstName = jQuery('#ContactForm-first-name').val()?.trim() || '';
        let lastName = jQuery('#ContactForm-last-name').val()?.trim() || '';
        let phone = jQuery('#ContactForm-phone').val()?.trim() || '';
        let digits = phone.replace(/\D/g, '');
        let email = jQuery('#ContactForm-email').val()?.trim() || '';
        let message = jQuery('#ContactForm-body').val()?.trim() || '';


        if (!nameRegex.test(firstName)) {
            showError('#ContactForm-first-name', 'Bitte gültigen Vornamen eingeben');
            isValid = false;
        }

        if (!nameRegex.test(lastName)) {
            showError('#ContactForm-last-name', 'Bitte gültigen Nachnamen eingeben');
            isValid = false;
        }

        if (digits.length < 7 || digits.length > 15) {
            showError('#ContactForm-phone', 'Ungültige Telefonnummer');
            isValid = false;
        }

        if (!emailRegex.test(email)) {
            showError('#ContactForm-email', 'Ungültige E-Mail');
            isValid = false;
        }

        if (message.length < 10) {
            showError('#ContactForm-body', 'Mindestens 10 Zeichen erforderlich');
            isValid = false;
        }


        if (!isValid) {

            e.preventDefault();
            e.stopImmediatePropagation();

            jQuery('.cnt-btn').after(
                '<div class="form-error-summary">Bitte korrigieren Sie die markierten Felder.</div>'
            );

            return false;
        }


        jQuery('.form-status, .form-status-list, .form__message')
            .addClass('js-success-message');

    });



    // ==========================
    // REMOVE ERROR ON INPUT
    // ==========================

    jQuery(document).on('input', '.field__input', function () {

        jQuery(this).removeClass('input-error');
        jQuery(this).next('.error-msg').remove();

        if (jQuery('.input-error').length === 0) {
            jQuery('.form-error-summary').remove();
        }


        if (jQuery('.js-success-message').length) {

            clearTimeout(window.successHideTimer);

            window.successHideTimer = setTimeout(function () {

                jQuery('.js-success-message').fadeOut(300, function () {
                    jQuery(this).remove();
                });

            }, 800);
        }

    });



    // ==========================
    // PHONE VALIDATION
    // ==========================

    jQuery(document).on('input', '#ContactForm-phone', function () {

        let phone = jQuery(this).val().trim();
        let digits = phone.replace(/\D/g, '');

        jQuery(this).removeClass('input-error');
        jQuery(this).next('.error-msg').remove();


        if (phone === '') return;


        if (!/^[0-9+\-\s()]*$/.test(phone)) {

            showError('#ContactForm-phone', 'Nur Zahlen erlaubt');
            return;

        }


        if (digits.length > 0 && digits.length < 7) {

            showError('#ContactForm-phone', 'Ungültige Telefonnummer');
            return;

        }

    });



    function showError(selector, message) {

        let field = jQuery(selector);

        field.addClass('input-error');

        field.next('.error-msg').remove();

        field.after(
            '<div class="error-msg">' + message + '</div>'
        );

    }



    // ==========================
    // SUCCESS MESSAGE HIDE
    // ==========================

    let success = jQuery('#contact-success-message');

    if (success.length) {

        setTimeout(function () {
            success.fadeOut(400);
        }, 3000);


        if (window.history.replaceState) {

            window.history.replaceState(
                {},
                document.title,
                window.location.pathname
            );

        }

    }



    // ==========================
    // SECTION CLASSES
    // ==========================

    jQuery("#shopify-section-template--31328242205010__1782536325d3129e34")
        .addClass("bottom-section-gapping bg-white-light");

        jQuery(".shopify-challenge__container").addClass("bottom-section-gapping");


    jQuery("#shopify-section-template--31328242303314__178253650455121d63")
        .addClass("bottom-section-gapping");





    // ==========================
    // HIDE FOOTER TOP SECTION
    // ==========================

    if (
        window.location.pathname.includes("/collections/") ||
        window.location.pathname.includes("/kategorie") ||
        jQuery("body").hasClass("template-collection")
    ) {

        jQuery(".footer-top-section").hide();

    }



    // ==========================
    // SEARCH VALIDATION
    // ==========================

    jQuery('.search-modal__form').on('submit', function (e) {

        let input = jQuery('#Search-In-Modal');
        let value = jQuery.trim(input.val());


        jQuery('.search-error-msg').remove();


        if (value === '') {

            e.preventDefault();

            input.addClass('search-error').focus();


            input.closest('.field').after(
                '<div class="search-error-msg">Bitte geben Sie einen Suchbegriff ein.</div>'
            );

            return false;

        }


        input.removeClass('search-error');

    });



    jQuery('#Search-In-Modal').on('input', function () {

        if (jQuery.trim(jQuery(this).val()) !== '') {

            jQuery(this).removeClass('search-error');

            jQuery('.search-error-msg').remove();

        }

    });

    jQuery('.inner-search').on('submit', function (e) {

        let input = jQuery('#Search-In-Template');
        let value = jQuery.trim(input.val());


        jQuery('.inner-search-error-msg').remove();


        if (value === '') {

            e.preventDefault();

            input.addClass('inner-search-error').focus();


            input.closest('.field').after(
                '<div class="inner-search-error-msg">Bitte geben Sie einen Suchbegriff ein.</div>'
            );

            return false;

        }


        input.removeClass('inner-search-error');

    });



    jQuery('#Search-In-Template').on('input', function () {

        if (jQuery.trim(jQuery(this).val()) !== '') {

            jQuery(this).removeClass('inner-search-error');

            jQuery('.inner-search-error-msg').remove();

        }

    });

    // ==========================
    // MOBILE MENU ACTIVE
    // ==========================

    let currentUrl = window.location.pathname;


    if (currentUrl === '/collections/alle-produkte') {

        jQuery('#HeaderDrawer-alle-produkte')
            .addClass('menu-drawer__menu-item--active')
            .attr('aria-current', 'page');

    }

     if (currentUrl === '/pages/kontakt') {

        jQuery('#HeaderDrawer-kontakt')
            .addClass('menu-drawer__menu-item--active')
            .attr('aria-current', 'page');

    }


    jQuery('#HeaderDrawer-alle-produkte').on('click', function () {

        jQuery('.menu-drawer__menu-item')
            .removeClass('menu-drawer__menu-item--active')
            .removeAttr('aria-current');


        jQuery(this)
            .addClass('menu-drawer__menu-item--active')
            .attr('aria-current', 'page');

    });



    // ==========================
    // PRODUCT PAGE MENU ACTIVE
    // ==========================

    if (jQuery("body").hasClass("template-product")) {

        jQuery('a[href*="/collections/alle-produkte"]')
            .addClass('menu-active');
            jQuery('#HeaderDrawer-alle-produkte').addClass('menu-drawer__menu-item--active').attr('aria-current','page')

    }


});
$(document).ready(function () {
    var currentUrl = window.location.href.split('?')[0].replace(/\/$/, '');

    $('.footer-block__details-content li a').each(function () {
        var linkUrl = this.href.split('?')[0].replace(/\/$/, '');

        if (currentUrl === linkUrl) {
            $(this)
                .addClass('active')
                .attr('aria-current', 'page');

            $(this).closest('li').addClass('active');
        }
    });
});
